import { getKajabiCtCookieValue } from '../utils/kajabi_ct_cookie';
import { getFBCookieValue } from '../utils/fb_cookie_value';
export const DEFAULT_PLAN_NAME = 'kajabi_growth_monthly';

export const sanitizeUserInput = (userInput: string, email = false) => {
  const userRegEx = /[<>{}{}=+\-/:*?&]/g;
  const emailRegEx = /[<>{}{}=\-/:*?&]/g;

  const sanitizedString = userInput?.replace(
    email ? emailRegEx : userRegEx,
    ''
  );
  return sanitizedString;
};

export const buildSignupUrl = (
  userData: {
    full_name: string | null;
    email: string;
    optimizely_id: string;
    signup_method: string | null;
  },
  aiError = false
) => {
  const planName = DEFAULT_PLAN_NAME;
  const baseUrl =
    process.env.REACT_APP_KAJABI_BASE_URL || 'https://app.kajabi.com';
  const kajabiVisitId = localStorage.getItem('kajabi_com_visit_id');
  const [unsanitizedFirstName, ...restNameArr] = (
    userData.full_name || ''
  ).split(/\s/);
  const firstName = sanitizeUserInput(unsanitizedFirstName);
  const lastName = sanitizeUserInput(restNameArr?.join(' '));
  const email = sanitizeUserInput(userData.email, true);

  return [
    baseUrl,
    '/signup/',
    planName,
    '?signup_source=ai_lead_gen',
    '&ai_lead_gen_error=',
    aiError,
    '&kajabi_com_visit_id=',
    kajabiVisitId,
    '&xid=206',
    '&first_name=',
    firstName,
    '&last_name=',
    lastName,
    '&email=',
    email,
    '&kexpe=leadgen',
    '&optimizely_id=',
    userData.optimizely_id,
    '&signup_method=',
    userData.signup_method,

    getKajabiCtCookieValue(),

    getFBCookieValue('_fbc'),
    getFBCookieValue('_fbp'),
  ]
    .filter(Boolean)
    .join('');
};

export const withGoogleUrl = () => {
  const auth0ClientDomain = process.env.REACT_APP_AUTH0_CLIENT_DOMAIN;
  const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

  const urlEndpoint = '/authorize?';

  // params
  const responseType = 'code';
  const scope = 'openid+profile+email';
  const prompt = 'login';
  const connection = 'Google-OAuth2';
  const signupMethod = 'google';
  const leadSource = 'ai-lead-gen';

  const urlParams = `client_id=${auth0ClientId}&response_type=${responseType}&scope=${scope}&prompt=${prompt}&connection=${connection}&signup_method=${signupMethod}&lead_source=${leadSource}`;

  return `https://${auth0ClientDomain}${urlEndpoint}${urlParams}`;
};
